var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _ellipse63, _ellipse64, _ellipse65, _ellipse66, _ellipse67, _ellipse68, _ellipse69, _ellipse70, _ellipse71, _ellipse72, _ellipse73, _ellipse74, _ellipse75, _ellipse76, _ellipse77, _ellipse78, _ellipse79, _ellipse80, _ellipse81, _ellipse82, _ellipse83, _ellipse84, _ellipse85, _ellipse86, _ellipse87, _ellipse88, _ellipse89, _ellipse90, _ellipse91, _ellipse92, _ellipse93, _ellipse94, _ellipse95, _ellipse96, _ellipse97, _ellipse98, _ellipse99, _ellipse100, _ellipse101, _ellipse102, _ellipse103, _ellipse104, _ellipse105, _ellipse106, _ellipse107, _ellipse108, _ellipse109, _ellipse110, _ellipse111, _ellipse112, _ellipse113, _ellipse114, _ellipse115, _ellipse116, _ellipse117, _ellipse118, _ellipse119, _ellipse120, _ellipse121, _ellipse122, _ellipse123, _ellipse124, _ellipse125, _ellipse126, _ellipse127, _ellipse128, _ellipse129, _ellipse130, _ellipse131, _ellipse132, _ellipse133, _ellipse134, _ellipse135, _ellipse136, _ellipse137, _ellipse138, _ellipse139, _ellipse140, _ellipse141, _ellipse142, _ellipse143, _ellipse144, _ellipse145, _ellipse146, _ellipse147, _ellipse148, _ellipse149, _ellipse150, _ellipse151, _ellipse152, _ellipse153, _ellipse154, _ellipse155, _ellipse156, _ellipse157, _ellipse158, _ellipse159, _ellipse160, _ellipse161, _ellipse162, _ellipse163, _ellipse164, _ellipse165, _ellipse166, _ellipse167, _ellipse168, _ellipse169, _ellipse170, _ellipse171, _ellipse172, _ellipse173, _ellipse174, _ellipse175, _ellipse176, _ellipse177, _ellipse178, _ellipse179, _ellipse180, _ellipse181, _ellipse182, _ellipse183, _ellipse184, _ellipse185, _ellipse186, _ellipse187, _ellipse188, _ellipse189, _ellipse190, _ellipse191, _ellipse192, _ellipse193, _ellipse194, _ellipse195, _ellipse196, _ellipse197, _ellipse198, _ellipse199, _ellipse200, _ellipse201, _ellipse202, _ellipse203, _ellipse204, _ellipse205, _ellipse206, _ellipse207, _ellipse208, _ellipse209, _ellipse210, _ellipse211, _ellipse212, _ellipse213, _ellipse214, _ellipse215, _ellipse216, _ellipse217, _ellipse218, _ellipse219, _ellipse220, _ellipse221, _ellipse222, _ellipse223, _ellipse224, _ellipse225, _ellipse226, _ellipse227, _ellipse228, _ellipse229, _ellipse230, _ellipse231, _ellipse232, _ellipse233, _ellipse234, _ellipse235, _ellipse236, _ellipse237, _ellipse238, _ellipse239, _ellipse240, _ellipse241, _ellipse242, _ellipse243, _ellipse244, _ellipse245, _ellipse246, _ellipse247, _ellipse248, _ellipse249, _ellipse250, _ellipse251, _ellipse252, _ellipse253, _ellipse254, _ellipse255, _ellipse256, _ellipse257, _ellipse258, _ellipse259, _ellipse260, _ellipse261, _ellipse262, _ellipse263, _ellipse264, _ellipse265, _ellipse266, _ellipse267, _ellipse268, _ellipse269, _ellipse270, _ellipse271, _ellipse272, _ellipse273, _ellipse274, _ellipse275, _ellipse276, _ellipse277, _ellipse278, _ellipse279, _ellipse280, _ellipse281, _ellipse282, _ellipse283, _ellipse284, _ellipse285, _ellipse286, _ellipse287, _ellipse288, _ellipse289, _ellipse290, _ellipse291, _ellipse292, _ellipse293, _ellipse294, _ellipse295, _ellipse296, _ellipse297, _ellipse298, _ellipse299, _ellipse300, _ellipse301, _ellipse302, _ellipse303, _ellipse304, _ellipse305, _ellipse306, _ellipse307, _ellipse308, _ellipse309, _ellipse310, _ellipse311, _ellipse312, _ellipse313, _ellipse314, _ellipse315, _ellipse316, _ellipse317, _ellipse318, _ellipse319, _ellipse320, _ellipse321, _ellipse322, _ellipse323, _ellipse324, _ellipse325, _ellipse326, _ellipse327, _ellipse328, _ellipse329, _ellipse330, _ellipse331, _ellipse332, _ellipse333, _ellipse334, _ellipse335, _ellipse336;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 582,
    viewBox: "0 0 77 582",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 488.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 501.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 514.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 527.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 540.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 488.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 501.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 514.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 527.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 540.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 488.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 501.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 514.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 527.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 540.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 488.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 501.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 514.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 527.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 540.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 488.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 501.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 514.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 527.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 540.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 488.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 501.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 514.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 527.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 540.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 540.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 553.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 566.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 579.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 540.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 553.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 566.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 579.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 540.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 553.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 566.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 579.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 540.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 553.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 566.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 579.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 540.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 553.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 566.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 579.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 540.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 553.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 566.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 579.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 384.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 397.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 410.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 423.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 436.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 384.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 397.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 410.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 423.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 436.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 384.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 397.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 410.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse68 || (_ellipse68 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 423.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse69 || (_ellipse69 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 436.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse70 || (_ellipse70 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 384.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse71 || (_ellipse71 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 397.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse72 || (_ellipse72 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 410.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse73 || (_ellipse73 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 423.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse74 || (_ellipse74 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 436.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse75 || (_ellipse75 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 384.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse76 || (_ellipse76 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 397.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse77 || (_ellipse77 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 410.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse78 || (_ellipse78 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 423.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse79 || (_ellipse79 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 436.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse80 || (_ellipse80 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 384.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse81 || (_ellipse81 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 397.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse82 || (_ellipse82 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 410.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse83 || (_ellipse83 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 423.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse84 || (_ellipse84 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 436.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse85 || (_ellipse85 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 436.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse86 || (_ellipse86 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 449.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse87 || (_ellipse87 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 462.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse88 || (_ellipse88 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 475.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse89 || (_ellipse89 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 488.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse90 || (_ellipse90 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 436.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse91 || (_ellipse91 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 449.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse92 || (_ellipse92 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 462.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse93 || (_ellipse93 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 475.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse94 || (_ellipse94 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 488.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse95 || (_ellipse95 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 436.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse96 || (_ellipse96 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 449.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse97 || (_ellipse97 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 462.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse98 || (_ellipse98 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 475.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse99 || (_ellipse99 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 488.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse100 || (_ellipse100 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 436.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse101 || (_ellipse101 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 449.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse102 || (_ellipse102 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 462.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse103 || (_ellipse103 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 475.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse104 || (_ellipse104 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 488.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse105 || (_ellipse105 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 436.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse106 || (_ellipse106 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 449.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse107 || (_ellipse107 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 462.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse108 || (_ellipse108 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 475.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse109 || (_ellipse109 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 488.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse110 || (_ellipse110 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 436.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse111 || (_ellipse111 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 449.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse112 || (_ellipse112 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 462.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse113 || (_ellipse113 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 475.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse114 || (_ellipse114 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 488.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse115 || (_ellipse115 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 280.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse116 || (_ellipse116 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 293.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse117 || (_ellipse117 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 306.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse118 || (_ellipse118 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 319.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse119 || (_ellipse119 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 332.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse120 || (_ellipse120 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 280.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse121 || (_ellipse121 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 293.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse122 || (_ellipse122 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 306.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse123 || (_ellipse123 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 319.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse124 || (_ellipse124 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 332.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse125 || (_ellipse125 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 280.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse126 || (_ellipse126 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 293.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse127 || (_ellipse127 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 306.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse128 || (_ellipse128 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 319.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse129 || (_ellipse129 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 332.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse130 || (_ellipse130 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 280.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse131 || (_ellipse131 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 293.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse132 || (_ellipse132 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 306.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse133 || (_ellipse133 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 319.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse134 || (_ellipse134 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 332.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse135 || (_ellipse135 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 280.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse136 || (_ellipse136 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 293.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse137 || (_ellipse137 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 306.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse138 || (_ellipse138 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 319.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse139 || (_ellipse139 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 332.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse140 || (_ellipse140 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 280.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse141 || (_ellipse141 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 293.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse142 || (_ellipse142 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 306.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse143 || (_ellipse143 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 319.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse144 || (_ellipse144 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 332.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse145 || (_ellipse145 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 332.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse146 || (_ellipse146 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 345.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse147 || (_ellipse147 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 358.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse148 || (_ellipse148 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 371.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse149 || (_ellipse149 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 384.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse150 || (_ellipse150 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 332.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse151 || (_ellipse151 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 345.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse152 || (_ellipse152 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 358.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse153 || (_ellipse153 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 371.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse154 || (_ellipse154 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 384.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse155 || (_ellipse155 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 332.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse156 || (_ellipse156 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 345.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse157 || (_ellipse157 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 358.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse158 || (_ellipse158 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 371.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse159 || (_ellipse159 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 384.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse160 || (_ellipse160 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 332.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse161 || (_ellipse161 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 345.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse162 || (_ellipse162 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 358.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse163 || (_ellipse163 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 371.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse164 || (_ellipse164 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 384.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse165 || (_ellipse165 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 332.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse166 || (_ellipse166 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 345.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse167 || (_ellipse167 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 358.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse168 || (_ellipse168 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 371.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse169 || (_ellipse169 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 384.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse170 || (_ellipse170 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 332.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse171 || (_ellipse171 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 345.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse172 || (_ellipse172 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 358.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse173 || (_ellipse173 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 371.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse174 || (_ellipse174 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 384.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse175 || (_ellipse175 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 176.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse176 || (_ellipse176 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 189.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse177 || (_ellipse177 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 202.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse178 || (_ellipse178 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 215.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse179 || (_ellipse179 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 228.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse180 || (_ellipse180 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 176.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse181 || (_ellipse181 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 189.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse182 || (_ellipse182 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 202.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse183 || (_ellipse183 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 215.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse184 || (_ellipse184 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 228.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse185 || (_ellipse185 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 176.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse186 || (_ellipse186 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 189.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse187 || (_ellipse187 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 202.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse188 || (_ellipse188 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 215.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse189 || (_ellipse189 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 228.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse190 || (_ellipse190 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 176.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse191 || (_ellipse191 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 189.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse192 || (_ellipse192 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 202.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse193 || (_ellipse193 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 215.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse194 || (_ellipse194 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 228.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse195 || (_ellipse195 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 176.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse196 || (_ellipse196 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 189.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse197 || (_ellipse197 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 202.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse198 || (_ellipse198 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 215.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse199 || (_ellipse199 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 228.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse200 || (_ellipse200 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 176.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse201 || (_ellipse201 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 189.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse202 || (_ellipse202 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 202.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse203 || (_ellipse203 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 215.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse204 || (_ellipse204 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 228.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse205 || (_ellipse205 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 228.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse206 || (_ellipse206 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 241.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse207 || (_ellipse207 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 254.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse208 || (_ellipse208 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 267.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse209 || (_ellipse209 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 280.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse210 || (_ellipse210 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 228.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse211 || (_ellipse211 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 241.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse212 || (_ellipse212 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 254.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse213 || (_ellipse213 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 267.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse214 || (_ellipse214 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 280.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse215 || (_ellipse215 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 228.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse216 || (_ellipse216 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 241.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse217 || (_ellipse217 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 254.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse218 || (_ellipse218 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 267.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse219 || (_ellipse219 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 280.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse220 || (_ellipse220 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 228.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse221 || (_ellipse221 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 241.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse222 || (_ellipse222 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 254.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse223 || (_ellipse223 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 267.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse224 || (_ellipse224 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 280.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse225 || (_ellipse225 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 228.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse226 || (_ellipse226 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 241.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse227 || (_ellipse227 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 254.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse228 || (_ellipse228 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 267.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse229 || (_ellipse229 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 280.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse230 || (_ellipse230 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 228.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse231 || (_ellipse231 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 241.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse232 || (_ellipse232 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 254.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse233 || (_ellipse233 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 267.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse234 || (_ellipse234 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 280.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse235 || (_ellipse235 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 72.7258,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse236 || (_ellipse236 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 85.6421,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse237 || (_ellipse237 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 98.5581,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse238 || (_ellipse238 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 111.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse239 || (_ellipse239 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 124.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse240 || (_ellipse240 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 72.7258,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse241 || (_ellipse241 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 85.6421,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse242 || (_ellipse242 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 98.5581,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse243 || (_ellipse243 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 111.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse244 || (_ellipse244 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 124.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse245 || (_ellipse245 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 72.7258,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse246 || (_ellipse246 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 85.6421,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse247 || (_ellipse247 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 98.5581,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse248 || (_ellipse248 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 111.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse249 || (_ellipse249 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 124.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse250 || (_ellipse250 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 72.7258,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse251 || (_ellipse251 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 85.6421,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse252 || (_ellipse252 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 98.5581,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse253 || (_ellipse253 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 111.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse254 || (_ellipse254 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 124.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse255 || (_ellipse255 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 72.7258,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse256 || (_ellipse256 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 85.6421,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse257 || (_ellipse257 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 98.5581,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse258 || (_ellipse258 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 111.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse259 || (_ellipse259 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 124.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse260 || (_ellipse260 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 72.7258,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse261 || (_ellipse261 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 85.6421,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse262 || (_ellipse262 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 98.5581,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse263 || (_ellipse263 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 111.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse264 || (_ellipse264 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 124.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse265 || (_ellipse265 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 124.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse266 || (_ellipse266 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 137.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse267 || (_ellipse267 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 150.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse268 || (_ellipse268 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 163.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse269 || (_ellipse269 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 176.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse270 || (_ellipse270 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 124.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse271 || (_ellipse271 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 137.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse272 || (_ellipse272 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 150.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse273 || (_ellipse273 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 163.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse274 || (_ellipse274 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 176.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse275 || (_ellipse275 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 124.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse276 || (_ellipse276 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 137.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse277 || (_ellipse277 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 150.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse278 || (_ellipse278 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 163.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse279 || (_ellipse279 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 176.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse280 || (_ellipse280 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 124.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse281 || (_ellipse281 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 137.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse282 || (_ellipse282 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 150.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse283 || (_ellipse283 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 163.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse284 || (_ellipse284 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 176.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse285 || (_ellipse285 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 124.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse286 || (_ellipse286 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 137.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse287 || (_ellipse287 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 150.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse288 || (_ellipse288 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 163.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse289 || (_ellipse289 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 176.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse290 || (_ellipse290 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 124.726,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse291 || (_ellipse291 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 137.642,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse292 || (_ellipse292 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 150.558,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse293 || (_ellipse293 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 163.474,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse294 || (_ellipse294 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 176.39,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse295 || (_ellipse295 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 7.47434,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse296 || (_ellipse296 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 20.3904,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse297 || (_ellipse297 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 7.47434,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse298 || (_ellipse298 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 20.3904,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse299 || (_ellipse299 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 7.47434,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse300 || (_ellipse300 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 20.3904,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse301 || (_ellipse301 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 7.47434,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse302 || (_ellipse302 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 20.3904,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse303 || (_ellipse303 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 7.47434,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse304 || (_ellipse304 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 20.3904,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse305 || (_ellipse305 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 7.47434,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse306 || (_ellipse306 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 20.3904,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse307 || (_ellipse307 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 20.7258,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse308 || (_ellipse308 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 33.6421,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse309 || (_ellipse309 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 46.5581,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse310 || (_ellipse310 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 59.4743,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse311 || (_ellipse311 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7258,
    cy: 72.3904,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse312 || (_ellipse312 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 20.7258,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse313 || (_ellipse313 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 33.6421,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse314 || (_ellipse314 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 46.5581,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse315 || (_ellipse315 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 59.4743,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse316 || (_ellipse316 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6353,
    cy: 72.3904,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse317 || (_ellipse317 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 20.7258,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse318 || (_ellipse318 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 33.6421,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse319 || (_ellipse319 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 46.5581,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse320 || (_ellipse320 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 59.4743,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse321 || (_ellipse321 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5451,
    cy: 72.3904,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse322 || (_ellipse322 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 20.7258,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse323 || (_ellipse323 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 33.6421,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse324 || (_ellipse324 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 46.5581,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse325 || (_ellipse325 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 59.4743,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse326 || (_ellipse326 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4547,
    cy: 72.3904,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse327 || (_ellipse327 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 20.7258,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse328 || (_ellipse328 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 33.6421,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse329 || (_ellipse329 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 46.5581,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse330 || (_ellipse330 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 59.4743,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse331 || (_ellipse331 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3645,
    cy: 72.3904,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse332 || (_ellipse332 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 20.7258,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse333 || (_ellipse333 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 33.6421,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse334 || (_ellipse334 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 46.5581,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse335 || (_ellipse335 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 59.4743,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })), _ellipse336 || (_ellipse336 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.274,
    cy: 72.3904,
    rx: 3.7258,
    ry: 3.7258,
    fill: "#A6F3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderImg);
export default __webpack_public_path__ + "static/media/sliderImg.da24abcd392347662b6002fcbe5c27d7.svg";
export { ForwardRef as ReactComponent };